import React from "react";
import { useState } from "react";
import "../../Styles/ChangeProfile.css";

const ChangeProfile = ({
  close,
  profilePicture,
  setProfilePicture,
  setOflineProfileUrl,
}) => {
  function onFileUploadChange(e) {
    var file = e.target.files[0];
    var fr = new FileReader();
    fr.onload = onFileReaderLoad;
    fr.readAsDataURL(file);
  }

  function onFileReaderLoad(e) {
    var bgStyle = e.target.result;
    setOflineProfileUrl(bgStyle);
  }

  return (
    <div className="modal-wrapper mobile-bottom">
      <div className="Gender">
        <div className="Gender-inside">
          <div className="Gender-inside-top">
            <div className="Gender-inside-top-text"></div>

            <div className="Gender-inside-top-image" onClick={close}>
              <img
                className="Gender-inside-top-image-img"
                src="imgs/Profile/editProfile.svg"
              />
            </div>
          </div>
          <div className="Gender-inside-center">
            <label className="Gender-inside-center-top" htmlFor="gallery">
              <img
                className="Gender-inside-center-top-img"
                src="imgs/Profile/gallery.svg"
              />
              <p className="Gender-inside-center-top-text">انتخاب از گالری</p>
              <input
                type="file"
                id="gallery"
                accept=".jpg, .jpeg, .png"
                onChange={(e) => {
                  setProfilePicture(e.target.files[0]);
                  close();
                  onFileUploadChange(e);
                }}
                hidden
              />
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ChangeProfile;
